import React from 'react';
import './StarRatingDisplay.css';

// Estrelas clicáveis, roxas — usadas pra editar a nota de uma avaliação
// existente no painel. Diferente da StarRating.jsx legada (cor amarela),
// já que aqui a cor roxa é o padrão pedido pro módulo de avaliações.
const StarRatingInput = ({ rating, onChange, size = 24 }) => (
  <div className="star-rating-display" role="radiogroup" aria-label="Nota da avaliação">
    {[1, 2, 3, 4, 5].map((i) => (
      <i
        key={i}
        role="radio"
        aria-checked={i === rating}
        aria-label={`${i} estrela${i > 1 ? 's' : ''}`}
        tabIndex={0}
        className={`fa ${i <= rating ? 'fa-star' : 'fa-star-o'} star-rating-display__star`}
        style={{ fontSize: size, cursor: 'pointer' }}
        onClick={() => onChange(i)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onChange(i);
        }}
      />
    ))}
  </div>
);

export default StarRatingInput;
